export class OrganiserFilter {
    constructor(private text?: string) {

    }
    static createOrganiserFilter(params?: OrganiserFilterParams): OrganiserFilter {
        var organiserFilter: OrganiserFilter = new OrganiserFilter();
        organiserFilter.text = params?.text;
        return organiserFilter;
    }
}

export interface OrganiserFilterParams {
    text?: string
}
